import { render } from "./PrintProductBarcode.vue?vue&type=template&id=7241beba"
import script from "./PrintProductBarcode.vue?vue&type=script&lang=js"
export * from "./PrintProductBarcode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__